// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WordExpandableText_wrapper__VFjdz","button":"WordExpandableText_button__x7BkM","shimmer":"WordExpandableText_shimmer__A9EPg"};